
import { defineComponent } from 'vue'

export default defineComponent({
    props: {
        title: {
            type: String,
            default: 'Indicator'
        },
        norm: {
            type: Number,
            default: 0
        },
        fact: {
            type: Number,
            default: 0
        },
        isExcess: {
            type: Boolean,
            default: false,
        },
        isPassed: {
            type: Boolean,
            default: false,
        },
        isPrice: {
            type: Boolean,
            default: false,
        }
    },
})
